<script lang="ts">
  import type { LayoutData } from './$types';
  import Loader from '$components/Transitions/Loader.svelte';
  import PageTransition from '$components/Transitions/PageTransition.svelte';

  import Analytics from '$components/Analytics.svelte';
  import CookieBanner from '$components/Cookies/Banner.svelte';

  export let data: LayoutData;

  $: transitionKey = data.url.pathname;
</script>

<Loader />

<PageTransition key={transitionKey}>
  <slot />
</PageTransition>

<Analytics />
<CookieBanner />
